'use strict'

const SET_BANNER_MESSAGE = "SET_BANNER_MESSAGE";
const BANNER_MESSAGE_DISPLAY = "BANNER_MESSAGE_DISPLAY";
const MARQUEE_BANNER_FLAG = "MARQUEE_BANNER_FLAG";
const BANNER_LOAD_REQUEST = "BANNER_LOAD_REQUEST";
const BANNER_LOAD_SUCCESS = "BANNER_LOAD_SUCCESS";
const BANNER_LOAD_FAILURE = "BANNER_LOAD_FAILURE";
export {
    SET_BANNER_MESSAGE,
    BANNER_MESSAGE_DISPLAY,
    MARQUEE_BANNER_FLAG,
    BANNER_LOAD_REQUEST,
    BANNER_LOAD_SUCCESS,
    BANNER_LOAD_FAILURE
}
